// extracted by mini-css-extract-plugin
export default {"block":"O5ABr","readOnlyBlock":"cjcCB","inner":"lmeF7","type":"nQdgs","value":"NzKvl"};